
import { Component, Prop, Vue, PropSync, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Choice, Value, ValueInputDS, EnumValueDSInput } from "@/graphql/API";
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import Factors from "@/store/modules/Factors";
import ChoiceValueDocumentsUploader from "@/components/ui/ChoiceValueDocumentsUploader.vue";
import FlashNotifications from "@/store/modules/FlashNotifications";
import { OpenAiTaskResult } from "@/graphql/custom";
const choiceModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const modelModule = getModule(Factors);
const flashNotificationsModule = getModule(FlashNotifications);
@Component({
    components: {
        ChoiceValueDocumentsUploader,
    },
})
export default class ChoiceValuesExtractor extends Vue {
    @PropSync("open", Boolean)
    syncedOpen!: boolean;

    @Prop({ default: true, type: Boolean })
    showIcon!: boolean;

    @Prop()
    choice!: Choice;

    @Prop({ default: false, type: Boolean })
    isEdit!: boolean;

    @Prop({ default: false, type: Boolean })
    showDelete!: boolean;

    @Prop()
    btnText!: string;

    @Prop({ default: true, type: Boolean })
    dialog!: boolean;

    @Prop({ default: false, type: Boolean })
    isDelete!: boolean;

    private choiceName = "";
    private deleteMode = false;
    private description = "";
    private loading = false;
    private valuesCreated = false;
    private fileId = "";

    get dialogTitle(): string {
        return "Extract values";
    }

    get selectedDecisionId(): number | null {
        return decisionsModule.selectedDecisionId;
    }

    get choiceLabelSingular(): string {
        return getModule(Decisions).choiceLabelSingular;
    }

    get deleteToggle(): boolean {
        return this.deleteMode || this.isDelete;
    }

    private closeDialog(): void {
        this.syncedOpen = false;
        this.choiceName = "";
        this.deleteMode = false;
        this.$emit("dialog-close");
    }

    get selectedChoiceValues(): { [id: string]: Value } | null {
        return choiceModule.choiceValues[this.choice.id];
    }

    private async extractValues(id: string): Promise<void> {
        this.loading = true;
        this.fileId = id;
        let taskIdResult = "";

        let rootId = modelModule.factorRoot?.id;

        let values = await choiceModule.getChoiceValues({
            choice_id: this.choice.id,
            parent_id: rootId,
        });
        let list = [];

        let allFactors = await modelModule.fetchAllFactors(
            decisionsModule.selectedDecisionId
                ? decisionsModule.selectedDecisionId
                : 1
        );

        if (allFactors && allFactors.length) {
            let prom = await Promise.all(
                allFactors.map(async (factor) => {
                    if (factor.is_group) {
                        await choiceModule.getChoiceValues({
                            choice_id: this.choice.id,
                            parent_id: factor.id,
                        });
                    }
                })
            );

            // const byFactorId = choiceModule.choiceValues[this.choice.id].reduce((acc, item) => {
            //       acc[item.factor_id] = item;
            //       return acc;
            //     }, {});

            let newObj: ValueInputDS[] = allFactors.map((factor) => {
                if (factor.value_type == "category") console.log(factor);

                let type = factor.is_group ? "group" : factor.value_type;
                let choice_name = this.choiceName;
                let choice_id =
                    this.selectedChoiceValues?.[factor.id]?.choice_id ?? 1;
                let factor_id = factor.id;
                let row_id: string =
                    this.selectedChoiceValues?.[factor.id]?.row_id ?? "";
                let value = this.selectedChoiceValues?.[factor.id]?.value ?? "";
                let enum_value_id = factor.enum_id ? factor.enum_id : null;
                let json: string =
                    this.selectedChoiceValues?.[factor.id]?.json ?? "";
                let options_values = enum_value_id
                    ? this.getFactorOptionsValues(enum_value_id)
                    : null;
                // let enum_values_obj_list = enum_value_id ? modelModule.enums[enum_value_id] : null;
                // if (enum_values_obj_list) console.log(enum_values_obj_list);

                return {
                    factor_name: factor.name,
                    type: type && type == "category" ? "Multiple Choice" : type && type == "string" ? "text" :  type,
                    choice_name: choice_name,
                    choice_id: choice_id,
                    factor_id: factor_id,
                    row_id: row_id,
                    value: value,
                    enum_value_id: enum_value_id,
                    options_values: options_values?.enum_values
                        ? options_values?.enum_values
                        : null,
                    options_obj_values: options_values?.enum_values_obj
                        ? options_values?.enum_values_obj
                        : null,
                    json: json,
                };
            });
            console.log(newObj);

            if (newObj) {
                try {
                    this.loading = true;
                    let extractValuesResults =
                        await choiceModule.extractChoiceValuesDS({
                            input: newObj,
                            file_ids: [this.fileId],
                        });
                    const results = JSON.parse(extractValuesResults);
                    if (results.success) {
                        if (results["task_id"]) {
                            try {
                                await this.getExtractedValuesResult(
                                    results["task_id"],
                                    0
                                );
                            } catch (error) {
                                this.loading = false;
                                console.error(
                                    "Error parsing extractChoiceValuesDS result JSON:",
                                    error
                                );
                            }
                        } else {
                            this.loading = false;
                            console.error("task_id not found in response");
                        }
                    } else {
                        this.loading = false;
                        console.error(
                            "Error parsing extractChoiceValuesDS result JSON:",
                            results.message
                        );
                        flashNotificationsModule.error({
                            message: results.message,
                            duration: 5000,
                        });
                    }
                } catch (error) {
                    flashNotificationsModule.error({
                        message: `Unexpected error, system cannot read this file`,
                        duration: 5000,
                    });
                    this.loading = false;
                }
            }
        }

        this.loading = false;
    }

    private async getExtractedValuesResult(
        task_id: string,
        requests: number
    ): Promise<OpenAiTaskResult | null | undefined> {
        if (task_id) {
            try {
                let results = await modelModule.getDsTaskResult({
                    task_id: task_id,
                });
                if (results) {
                    let taskStatus = results.task.status;
                    if (taskStatus == "SUCCESS") {
                        let taskResult = JSON.parse(results.result);
                        if (results.result)
                            if (taskResult["extracted_values"]) {
                                try {
                                    flashNotificationsModule.success({
                                        message: ` Values have been successfully extracted. You can now proceed with reviewing or editing them.`,
                                        duration: 5000,
                                    });
                                    choiceModule.setUpdatedChoice(this.choice);

                                    this.loading = false;
                                    this.$router.push({
                                        name: "Choices",
                                        query: { customMetaValue: "someValue" },
                                    });
                                } catch (error) {
                                    this.loading = false;
                                    console.error(
                                        "Error parsing extracted_values JSON:",
                                        error
                                    );
                                }
                            } else {
                                this.loading = false;
                                console.error(
                                    "extracted_values not found in response"
                                );
                            }
                    } else if (taskStatus == "PENDING" && requests <= 6) {
                        /*
                            If pending then returns a promise of a timeout that waits
                            and calls the function again with requests + 1

                            Promise required an undefined type
                        */
                        return await new Promise<
                            OpenAiTaskResult | null | undefined
                        >((resolve) => {
                            setTimeout(() => {
                                this.getExtractedValuesResult(
                                    task_id,
                                    requests + 1
                                ).then(
                                    (
                                        values:
                                            | OpenAiTaskResult
                                            | null
                                            | undefined
                                    ) => {
                                        resolve(values ? values : null);
                                    }
                                );
                            }, 15000);
                        }).then(
                            (values: OpenAiTaskResult | null | undefined) => {
                                return values;
                            }
                        );
                    } else if (taskStatus == "FAILURE") {
                        flashNotificationsModule.error({
                            message: `Unexpected error, task has status FAILURE`,
                            duration: 5000,
                        });
                        this.loading = false;
                        return null;
                    } else {
                        this.loading = false;
                        flashNotificationsModule.warning({
                            message: `It looks like the process is taking too long. Try one more time.`,
                            duration: 10000,
                        });
                        return null;
                    }
                }
            } catch (error) {
                this.loading = false;
                flashNotificationsModule.error({
                    message: `Unexpected error: ${error}`,
                    duration: 10000,
                });
                console.log(
                    "%cError getExtractedValuesResult():",
                    "color: red; font-weight: bold;"
                );
                console.log(error);
                return null;
            }
        }
    }

    mounted(): void {
        this.onChoiceChange();
    }

    @Watch("isEdit")
    onIsEdit(): void {
        this.onChoiceChange();
    }

    @Watch("choice", { immediate: true, deep: true })
    onChoiceChange(): void {
        if (this.isEdit && this.choice) {
            this.choiceName = this.choice.name;
            this.description = this.choice.description;
        } else {
            this.choiceName = "";
            this.description = "";
        }
    }

    private updateTextDescription(val: string): void {
        this.description = val;
    }

    private getFactorOptionsValues(factor_enum_id: number): {
        enum_values_obj: EnumValueDSInput[];
        enum_values: string[];
    } {
        let enum_values: string[] = [];
        let enum_values_obj: EnumValueDSInput[] = [];
        let enum_values_obj_list = modelModule.enums[factor_enum_id];
        if (
            enum_values_obj_list.values &&
            enum_values_obj_list.values.length > 0
        )
            enum_values_obj_list.values.forEach((enum_value) => {
                enum_values.push(enum_value.value);
                enum_values_obj.push({
                    id: enum_value.id,
                    value: enum_value.value,
                });
            });
        return {
            enum_values_obj: enum_values_obj,
            enum_values: enum_values,
        };
    }
}
